import React from 'react';
import ConditionalWrap from 'conditional-wrap';

import DynamicSubLayout from 'core/components/DynamicSubLayout';
import CtrlHolder from 'pods/forms/components/structural/CtrlHolder';
import IFormFieldProps from 'pods/forms/components/formFieldProps.d';
import * as Typo from 'core/styles/Typography';

import * as S from './FormSubLayout.style';

interface IProps extends IFormFieldProps {
	children: any;
}

const FormSubLayout = ({ children, config }: IProps) => {
	const {
		fieldsetOneLineError,
		htmlId,
		targetFields,
		isFieldset,
		legend,
		noMargin,
		disabled,
		noStack,
		...subLayoutProps
	} = config?.data ?? {};

	let fieldsetError;
	//this will filter the error message
	//and set one line of error in Sublayout container for specific fieldset
	if (fieldsetOneLineError && htmlId && targetFields) {
		if (children) {
			//set any as data-type to cater dynamic fields
			children.forEach((field: any) => {
				const fieldError = field.props.formik.errors[targetFields[0]];
				if (fieldError) {
					//there is only 1 validation for all of the fields in fieldset
					//it doesn't  matter if we check only one field error
					fieldsetError = fieldError[0];
				}
			});
		}
	}

	return (
		<CtrlHolder
			{...{ noMargin }}
			htmlId={fieldsetOneLineError && htmlId ? htmlId : null}
			errorMsg={fieldsetOneLineError && htmlId ? fieldsetError : ''}
			hasErrorIcon={fieldsetOneLineError && htmlId}
		>
			<ConditionalWrap
				condition={isFieldset}
				wrap={(children: React.ReactNode) => (
					<S.FieldSet {...{ disabled }}>
						<Typo.SubHeading tag="legend" jss={legend} />
						{children}
					</S.FieldSet>
				)}
			>
				<S.Wrapper>
					<DynamicSubLayout
						stackAt={noStack ? null : 'xxs'}
						{...subLayoutProps}
					>
						{children}
					</DynamicSubLayout>
				</S.Wrapper>
			</ConditionalWrap>
		</CtrlHolder>
	);
};

export default FormSubLayout;
